import { render, staticRenderFns } from "./StatusUpdater.vue?vue&type=template&id=20a81243&scoped=true&"
import script from "./StatusUpdater.vue?vue&type=script&lang=js&"
export * from "./StatusUpdater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a81243",
  null
  
)

export default component.exports